/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import * as React from 'react';
import {Link} from 'react-router-dom';
import {ADMIN_ROLE, NOTAVAILABLE} from '../../constants/global';

import {MONTHNAMES} from '../../constants/index';
import {removeSpace} from '../../utils/utils';
import ExpandedTableRow from './ExpandedTableRow';

export const RenderBody = props => {
  const {row, rowIndex, orgId, expandedOrg, setExpandedOrg} = props;

  const isExpanded = orgId === expandedOrg;

  /**
   * row - is the data from api
  */
  return(
    <>
      <tr>
        {
          row?.map((cell, index) => (index===0)?
        <th id={`th${index}_${rowIndex}`} className='tabledataheader' style={{width: '200px', padding: '16px'}} scope='row' key={index}>{cell}</th>:
        <td id={`td${index}-${rowIndex}`} style={{padding: '16px'}} key={`${index}-${rowIndex}`}>{cell}</td>)
        }
        <td scope="col" className="cb-table-expandable-trigger tableexpandheader" onClick={() => {
          if(isExpanded) {
            //collapse the section
            setExpandedOrg(null);
          }
          else {
            //expand the section
            setExpandedOrg(orgId);
          }
        }}>
          <span className={isExpanded?"cb-icon cb-up":"cb-icon cb-down"} aria-hidden="true"></span>
        </td>
      </tr>
      {isExpanded && <tr className="cb-table-expandable-row bluepanel" aria-hidden="false">
        <td colSpan="5" className="cb-table-expandable-container">
          <ExpandedTableRow orgId={orgId}/>
        </td>
      </tr>}
    </>
  );
};
RenderBody.propTypes = {
  row: PropTypes.array,
  rowIndex: PropTypes.number
};
/**
* headers - array of strings
* combined with sorting feeatures
* @param {array} param0
*/
export const RenderHeader = props => {
  const {headers, coldata, metdav, ordering, orderingStatus, glyicon, sortTable, dispatcher} = props;
  return(
    <thead>
      <tr>
        {headers.map((head, index) => (
          <th scope='col' 
            aria-sort={orderingStatus[index]}
            className='tableheader cb-table-sort-joined' id={removeSpace(`${head}`)} key={head}>
            <Link style={{width: "100%"}} to='#' onClick={() => {
                let newOrderingStatus = ['none','none','none','none'];
                ordering[index] = !ordering[index];
                if(ordering[index]===true) {
                  glyicon[index]='cb-icon cb-sort-asc';
                  newOrderingStatus[index] = 'ascending';
                } else {
                  glyicon[index]='cb-icon cb-sort-desc';
                  newOrderingStatus[index] = 'descending';
                }
                dispatcher({type:'SET_ORDERING_STATUS', payload:newOrderingStatus});

                glyicon.forEach((el, arr_ind) => {
                  if(index!==arr_ind) {
                    glyicon[arr_ind] = 'cb-icon cb-sort';
                  }
                });
                sortTable(index, ordering[index], metdav);
              }}>
                <span> {head} </span>
                <span aria-hidden='true' id={`tabler${index}clickheader`} className={`${glyicon[index]}`}>
                </span>
            </Link>
          </th>
        ))}
        <th scope='col' className='tableheader tableexpandheader'/> 
      </tr>
    </thead>
  );
};
RenderHeader.propTypes = {
  headers: PropTypes.array,
  metdav: PropTypes.array,
  ordering: PropTypes.array,
  glyicon: PropTypes.array,
  sortTable: PropTypes.func
};

export const renderTableBody = ({tableData, onclickAction}) => {
  const [expandedOrg, setExpandedOrg] = React.useState(null);
  return (
    tableData.map((row, index) => (
      (<RenderBody key={index} rowIndex={index} row={[
        <nav style={{width: "100%"}} key={`${row.org_id}_${index}`} className='btnedit' id={`btn_${row.id}`}>
          <Link
            onClick={() => onclickAction(row.org_name)}
            to={`/organizations/${row.org_id}/categories/${0}/${ADMIN_ROLE}`}
            state={{
              CategoryName: row.org_name
            }}
          >
            <p>{row.org_name}</p>
          </Link>
        </nav>,
        `${row.org_id}`,
        `${row.state?row.state:''}`,
        `${row?.zone_name || NOTAVAILABLE}`,
      ]} orgId={row.org_id} expandedOrg={expandedOrg} setExpandedOrg={setExpandedOrg}/>)
    ))
  )
};